import React, { useEffect, useState } from "react";
import LoaderAnimation from "./LoaderAnimation";
import SecureLS from "secure-ls";
import MessageModal from "./MessageModal";
import { faCircleCheck, faClose } from "@fortawesome/free-solid-svg-icons";

const EditClientAttachedToVoucher = ({ clientDataForEditState }) => {
  const [loading, setLoading] = useState(false);
  const [clientFirstName, setClientFirstName] = useState(
    clientDataForEditState.field_first_name
  );
  const [clientLastName, setClientLastName] = useState(
    clientDataForEditState.field_last_name
  );
  const [clientGender, setClientGender] = useState(
    clientDataForEditState.field_gender
  );
  const [clientDateOfBirth, setClientDateOfBirth] = useState(
    clientDataForEditState.field_date_of_birth
  );
  const [clientEmail, setClientEmail] = useState(
    clientDataForEditState.field_client_email_address
  );
  const [clientLocation, setClientLocation] = useState(
    clientDataForEditState.field_location
  );
  const [clientContact, setClientContact] = useState(
    clientDataForEditState.field_contact_number
  );

  const [isMessageModalVisibleAddRequest, setIsMessageModalVisibleAddRequest] =
    useState(false);
  const toggleModalClose = () => {
    setIsMessageModalVisibleAddRequest(false);
  };

  const ls = new SecureLS({ encodingType: "aes" });

  useEffect(() => {
    console.log("clientDataForEditState????", clientDataForEditState);
    console.log(
      "clientDataForEditState Client ID????",
      clientDataForEditState.client_nid
    );
  }, [clientDataForEditState]);

  if (loading) {
    return <LoaderAnimation />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const username = ls.get("username");
      const userpw = ls.get("userpw");
      const usercsrf_token = ls.get("usercsrf_token");

      if (!username || !userpw || !usercsrf_token) {
        alert("Missing credentials. Please log in again.");
        setLoading(false);
      }

      const clientEditDataPayload = {
        type: [{ target_id: "client" }],
        field_gender: [{ value: clientGender }],
        field_date_of_birth: [{ value: clientDateOfBirth }],
        field_client_email_address: [{ value: clientEmail }],
        field_location: [{ value: clientLocation }],
      };

      const response = await fetch(
        `${process.env.REACT_APP_SLASH_NODE_URL}/${clientDataForEditState.client_nid}?_format=json`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
            "Content-Type": "application/json",
            "X-CSRF-Token": usercsrf_token,
          },
          body: JSON.stringify(clientEditDataPayload),
        }
      );

      const responseData = await response.json();
      if (!response.ok) {
        // Handle validation errors from Drupal
        if (response.status === 500 && responseData.message) {
          // This will catch your EntityStorageException
          throw new Error(responseData.message);
        } else if (responseData.message) {
          // Other Drupal validation errors
          throw new Error(responseData.message);
        } else {
          // Generic error if no message is present
          throw new Error("Failed to submit client data");
        }
      }

      setIsMessageModalVisibleAddRequest(true);

      // Clear form fields
      setClientDateOfBirth("");
      setClientGender("");
      setClientContact("");
      setClientLocation("");
      setClientFirstName("");
      setClientLastName("");
      setClientEmail("");
    } catch (error) {
      console.error("Error:", error);
      // Display the error message from the server or a generic message
      alert(error.message || "An error occurred while submitting the form");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-ctscan-request-register">
      <form onSubmit={handleSubmit} className="patient-form">
        <div className="form-group">
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            placeholder="Enter first name"
            value={clientFirstName}
            // onChange={(e) => setClientFirstName(e.target.value)}
            disabled
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            placeholder="Enter last name"
            value={clientLastName}
            // onChange={(e) => setClientLastName(e.target.value)}
            disabled
          />
        </div>
        <div className="form-group">
          <label htmlFor="contact">Contact Number</label>
          <input
            type="tel"
            placeholder="Enter contact number"
            value={clientContact}
            // onChange={(e) => setClientLastName(e.target.value)}
            disabled
          />
        </div>
        <div className="form-group">
          <label htmlFor="gender">Gender</label>
          <select
            value={clientGender}
            onChange={(e) => setClientGender(e.target.value)}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="dob">Date of Birth</label>
          <input
            type="date"
            value={clientDateOfBirth}
            onChange={(e) => setClientDateOfBirth(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            placeholder="Enter email address"
            value={clientEmail}
            onChange={(e) => setClientEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            placeholder="Enter location"
            value={clientLocation}
            onChange={(e) => setClientLocation(e.target.value)}
            required
          />
        </div>
        <div className="submitGroup">
          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
      {isMessageModalVisibleAddRequest && (
        <MessageModal
          leftIcon={faCircleCheck}
          color="green"
          fontSize={20}
          message="Client edit successfully!"
          onClose={toggleModalClose}
          rightIcon={faClose}
        />
      )}
    </div>
  );
};

export default EditClientAttachedToVoucher;
